module.exports = "/assets/listing/pizzaweekBannerMobile.jpg?l6AKQ+/";